import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function HomeOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_140)'>
        <path
          d='M20.4201 10.1799L12.7101 2.29995C12.6172 2.20622 12.5066 2.13183 12.3847 2.08106C12.2628 2.03029 12.1321 2.00415 12.0001 2.00415C11.8681 2.00415 11.7374 2.03029 11.6155 2.08106C11.4937 2.13183 11.3831 2.20622 11.2901 2.29995L3.58012 10.1899C3.39355 10.378 3.24621 10.6013 3.14664 10.8468C3.04708 11.0922 2.99727 11.3551 3.00012 11.6199V19.9999C2.99934 20.5119 3.19489 21.0046 3.54649 21.3766C3.89809 21.7487 4.37898 21.9718 4.89012 21.9999H19.1101C19.6213 21.9718 20.1021 21.7487 20.4537 21.3766C20.8053 21.0046 21.0009 20.5119 21.0001 19.9999V11.6199C21.0009 11.0829 20.7929 10.5665 20.4201 10.1799ZM10.0001 19.9999V13.9999H14.0001V19.9999H10.0001ZM19.0001 19.9999H16.0001V12.9999C16.0001 12.7347 15.8948 12.4804 15.7072 12.2928C15.5197 12.1053 15.2653 11.9999 15.0001 11.9999H9.00012C8.7349 11.9999 8.48055 12.1053 8.29301 12.2928C8.10547 12.4804 8.00012 12.7347 8.00012 12.9999V19.9999H5.00012V11.5799L12.0001 4.42995L19.0001 11.6199V19.9999Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_140'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
